import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadAdjustmentRuleEpic } from './_epics/loadAdjustmentRule.epic';
import { updateAdjustmentRuleEpic } from './_epics/updateAdjustmentRule.epic';
import { validateAdjustmentRuleEpic } from './_epics/validateAdjustmentRule.epic';
import { reloadAdjustmentRuleListEpic } from './_epics/reloadAdjustmentRule.epic';
import { exportAdjustmentRulesEpic } from './_epics/exportAdjustmentRules.epic';

export const adjustmentRuleEpic = safeCombineEpics(
  loadAdjustmentRuleEpic,
  updateAdjustmentRuleEpic,
  validateAdjustmentRuleEpic,
  reloadAdjustmentRuleListEpic,
  exportAdjustmentRulesEpic,
);
